$(document).ready(function(){
  
  // product page slider image change swatch
  $('input.custom_swatch').click(function(){
    setTimeout(function() { 
      var current_url = window.location.href;
      var current_url_split = current_url.split('?')[1];
      var current_url_split_new = current_url_split.split('=')[1];
      
      $('.colors_variants').each(function(){
        var variants_id = $(this).attr('variants-id');
        if(current_url_split_new == variants_id ) {
          var selected_image = $(this).attr('varinat-image');
          var selected_image_new = selected_image.split('/')[6];
          var selected_image_new1 = selected_image_new.split('?')[0];
          
          $('.custon_images_variants').each(function(){
            var variants_slider_img = $(this).attr('src');
            if(variants_slider_img.includes(selected_image_new1)){
              $(this).trigger('click'); 
            }
          });
        }
      });
    }, 500);
  });

  // product page tabs
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    
    $(this).find('a').click(function(e){
      active.removeClass('active');
      active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  
    $(this).find('.reviews').click(function(e){
      $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
    });
   
 });

  $('.site-product-page .apps_enabled #judgeme_product_reviews').hide();

  $('.site-product-page a.reviews').click(function(){
    $('.site-product-page .apps_enabled #judgeme_product_reviews').show();
  });
    
  $('a.description.active').click(function(){
    $('.site-product-page .apps_enabled #judgeme_product_reviews').hide();
  });
  
});